<template>
  <div>
    <Header :topVal="navBarFixed"></Header>
    <app-main></app-main>
    <Footer></Footer>
  </div>
</template>

<script>
import { Header, Footer, AppMain } from "./components";
export default {
  components: {
    Header,
    Footer,
    AppMain,
  },
  data() {
    return {
      navBarFixed: false,
    };
  },
  methods: {
    scrolling() {
      // 滚动条距文档顶部的距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log("header 滚动距离 ", scrollTop);
      if (scrollTop > 500) {
        this.navBarFixed = true;
      } else {
        this.navBarFixed = false;
      }
    },
    add() {
      // 监听页面滚动事件
      window.addEventListener("scroll", this.scrolling);
    },
    remove() {
      window.removeEventListener("scroll", this.scrolling);
    },
  },
  mounted() {
    this.add();
  },
  beforeDestroy() {
    this.remove();
  },
};
</script>
